export default __webpack_public_path__ + "static/media/loader.35521c78.svg";